import { render, staticRenderFns } from "./SharedItemsTab.vue?vue&type=template&id=47ce16f2&scoped=true"
import script from "./SharedItemsTab.vue?vue&type=script&lang=js"
export * from "./SharedItemsTab.vue?vue&type=script&lang=js"
import style0 from "./SharedItemsTab.vue?vue&type=style&index=0&id=47ce16f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce16f2",
  null
  
)

export default component.exports